import React, { useState } from "react";
import AddNewManager from "../../pages/addNewManager/AddNewManager";
import Register from "../../pages/register/Register";
import "./addAccount.css";
import MobileNav from "../../components/mobileNav/MobileNav";

// Sample forms
const ManagerAccount = () => (
  <div className="form-card">
    <AddNewManager />
  </div>
);

const TechAccount = () => (
  <div className="form-card">
    <Register />
  </div>
);

const AddAccount = () => {
  const [selectedType, setSelectedType] = useState("");

  return (
    <>
      <MobileNav />
      <div className="addAccount">
        <div className="addAccount-container">
          <h2>انشاء حساب</h2>
          <div className="radio-group">
            <label
              className={`radio-option ${
                selectedType === "manager" ? "selected" : ""
              }`}
            >
              <input
                type="radio"
                name="accountType"
                value="manager"
                onChange={(e) => setSelectedType(e.target.value)}
              />
              حساب مدير
            </label>
            <label
              className={`radio-option ${
                selectedType === "tech" ? "selected" : ""
              }`}
            >
              <input
                type="radio"
                name="accountType"
                value="tech"
                onChange={(e) => setSelectedType(e.target.value)}
              />
              حساب فني
            </label>
          </div>

          <div className="form-wrapper">
            {selectedType === "" && (
              <div className="placeholder">
                <p>من فضلك اختر نوع الحساب لعرض النموذج المناسب.</p>
              </div>
            )}
            {selectedType === "manager" && <ManagerAccount />}
            {selectedType === "tech" && <TechAccount />}
          </div>
        </div>
      </div>
    </>
  );
};

export default AddAccount;
